/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterW = createReactComponent(
  "square-rounded-letter-w",
  "IconSquareRoundedLetterW",
  [
    ["path", { d: "M9 8l1 8l2 -5l2 5l1 -8", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedLetterW as default };
//# sourceMappingURL=IconSquareRoundedLetterW.js.map
